import React, { useEffect, useRef, useState } from "react";
import PropertyListGrid from "../property-list-grid";
import MapBox from "../map-box";
import styles from "./property-listing.module.scss";
import PropertyListHeader from "../property-list-header";
// import SkeletonC from "../../common/skeleton";
// import PropertyListHeaderSkeleton from "../../../skeleton/property-list/PropertyListHeaderSkeleton";
// import { SideBarProps } from "./sidebar-tab.interface";
// import HeaderSkeleton from "./headerskeleton";
import Header from "./header";
import ListTable from "./listTable";
import { useInView } from "react-intersection-observer";
import useProperty from "../../../hooks/context/useProperty";
import MobilePropertiesHeader from "../../common/mobile-properties-header";
import PropertyListCardSkeleton from "../../../skeleton/card-skeleton";
import { useSearchParams } from "react-router-dom";
import { useDebounce } from "primereact/hooks";
import NoDataFoundC from "../../common/no-data-found";
import BeatLoaderC from "../../common/DataLoader";
import PropertyListSkeleton from "../../../skeleton/list-skeleton";
import ListHeaderSkeleton from "../../../skeleton/listing-header";
import ListHeaderTitleSkeleton from "../../../skeleton/listing-header-title";
import PreListTable from "./pre-list-table";
import { usePreList } from "../../../hooks/react-query/properties/usePreList";
import PreListCards from "./pre-list-cards";

const PropertyListing = ({
  arrProperty,
  fetchNextPage,
  hasNextPage,
  isLoading,
  isPlaceholderData,
  isFetchingNextPage,
  type,
  arrMapProperty
}: any) => {
  const [layout, setLayout] = useState(
    localStorage.getItem("layout") ?? "grid"
  );
  
  // Handle different data structures: investor has data: [], agent has data: { properties: [] }
  const getProperties = (pageData: any) => {
    return type === "investor" ? pageData : pageData?.properties;
  };

  const renderPropertyGrid = (pages: any[] | undefined | null) => {
    const content =
      pages
        ?.map((page: { data: any }) => {
          const properties = getProperties(page?.data);
          if (!properties?.length) return null;

          return (
            <React.Fragment key={JSON.stringify(page.data)}>
              <div className={styles.propertyWrap}>
                {properties.map((tableData: any) => (
                  <React.Fragment key={tableData.id}>
                    <div>
                      <PropertyListGrid
                        type={type}
                        showMap={showMap}
                        loading={isLoading}
                        isPlaceholderData={isPlaceholderData}
                        objProperty={tableData}
                      />
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </React.Fragment>
          );
        })
        ?.filter(Boolean) ?? [];

    return content.length ? content : null;
  };

  // Flatten pre-list data from infinite query pages
  const getPreListData = () => {
    if (!arrPreList?.pages) return [] as any[];
    const allPreData: any[] = [];
    arrPreList.pages.forEach((page: any) => {
      const pageData = page?.data;
      if (Array.isArray(pageData)) {
        allPreData.push(...pageData);
      } else if (Array.isArray(pageData?.data)) {
        // handle nested data arrays if API wraps response
        allPreData.push(...pageData.data);
      }
      // otherwise skip non-iterable shapes
    });
    return allPreData;
  };
  
  const fullCount = type === "investor"
    ? arrProperty?.pages[0]?.data?.[0]?.full_count || 0
    : arrProperty?.pages[0]?.data?.properties?.[0]?.full_count || 0;

  const [showMap, setShowMap] = useState<boolean>(() => {
    return localStorage.getItem("showMap") === "false" ? false : true;
  });
  const listingWrapRef: any = useRef<HTMLDivElement>(null);
  const { hoveredProperty } = useProperty();
  const [totalCount, setTotalCount] = useState(fullCount ?? 0);

  const [searchParams, setSearchParams] = useSearchParams();

  // Pre toggle: disable on mobile view; otherwise respect URL param (default true) for agents
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;
  const isPreOn =
    type === "agent" && (searchParams.get("showPre") === null
      ? true
      : searchParams.get("showPre") === "true");

  // Pre-list data hook
  const {
    arrPreList,
    isLoading: isPreListLoading,
    fetchNextPage: fetchNextPrePage,
    hasNextPage: hasNextPrePage,
    isFetchingNextPage: isFetchingNextPrePage,
    isPlaceholderData: isPreListPlaceholderData
  } = usePreList({ type });

  const [searchValue, debouncedSearchValue, setSearchValue] = useDebounce(
    searchParams.get("searchText") || "",
    400
  );

  const preListData = getPreListData();
  const preTotalCount =
    arrPreList?.pages?.[0]?.totalCount ??
    (Array.isArray(preListData) ? preListData.length : 0);

  useEffect(() => {
    setTotalCount(fullCount);
  }, [arrProperty]);

  useEffect(() => {
    setIsPreListExpanded(false);
  }, [isPreOn]);

  const [expand, setExpand] = useState(false);
  const { ref, inView } = useInView({
    threshold: 0
  });
  const [isPreListExpanded, setIsPreListExpanded] = useState(false);
  const effectiveShowMap =
    isMobile && !isPreOn ? (!isPreListExpanded ? true : showMap) : showMap;
  const increaseWidth = () => {
    setExpand(!expand);
  };

  const handleScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
    if (scrollHeight - scrollTop <= clientHeight + 10) {
      if (hasNextPage) {
        fetchNextPage();
      }
    }
  };

  useEffect(() => {
    if (isPreOn) {
      // Handle pre-list infinite scroll
      if (inView && hasNextPrePage && arrPreList?.pages) {
        fetchNextPrePage();
      }
    } else {
      // Handle regular property infinite scroll
      if (
        inView &&
        hasNextPage &&
        arrProperty?.pages &&
        (type === "investor" 
          ? arrProperty.pages[0].data?.totalPages > arrProperty.pages.length
          : arrProperty.pages[0].data?.properties?.totalPages > arrProperty.pages.length)
      ) {
        handleScroll();
      }
    }
  }, [arrProperty, arrPreList, inView, hasNextPage, hasNextPrePage, type, isPreOn, fetchNextPrePage]);

  const objPropertyListH: any = {
    // options: sortByOptions,
    // optionLabel: "name",
    // title: "Homes in California",
    title: `${totalCount} ${totalCount > 1 ? "Listings" : "Listing"}  Found`
    // sub_title: `${totalCount} listing found in California`
  };
  useEffect(() => {
    const handleScroll = () => {
      if (listingWrapRef.current) {
        sessionStorage.setItem(
          "mapScrollPosition",
          listingWrapRef.current.scrollTop
        );
      }
    };

    const listingWrap = listingWrapRef.current;
    if (listingWrap) {
      listingWrap.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (listingWrap) {
        listingWrap.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    const savedScrollPosition = sessionStorage.getItem("mapScrollPosition");
    if (savedScrollPosition && listingWrapRef.current) {
      listingWrapRef.current.scrollTo(0, parseInt(savedScrollPosition, 10));
    }
  }, []);
  useEffect(() => {
    if (
      inView &&
      hasNextPage &&
      arrProperty?.pages &&
      fullCount > arrProperty?.pages?.length
    ) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, fetchNextPage]);
  const skeletonArray = new Array(10).fill({ id: 0 });

  return (
    <div className={styles.sidebarWrap}>
      <>
        <Header
          type={type}
          searchValue={searchValue}
          debouncedSearchValue={debouncedSearchValue}
          setSearchValue={setSearchValue}
          layout={layout}
          setLayout={setLayout}
        />
        <MobilePropertiesHeader
          type={type}
          searchValue={searchValue}
          debouncedSearchValue={debouncedSearchValue}
          setSearchValue={setSearchValue}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      </>
      <div className={styles.listingWrap}>
        {isPreOn ? (
          !isPreListLoading ? (
            <>
              {preTotalCount > 0 && (
                <div className={`${showMap ? styles.header : ""}`}>
                  <PropertyListHeader
                    title={`${preTotalCount} ${preTotalCount > 1 ? "Pre Listings" : "Pre Listing"} Found`}
                    type={type}
                  />
                </div>
              )}
            </>
          ) : (
            <div className={`${showMap ? styles.header : ""}`}>
              <ListHeaderSkeleton />
            </div>
          )
        ) : (
          !isLoading ? (
            <>
              {totalCount > 0 && (
                <div className={`${showMap ? styles.header : ""}`}>
                  <PropertyListHeader
                    title={objPropertyListH.title}
                    type={type}
                  />
                </div>
              )}
            </>
          ) : (
            <div className={`${showMap ? styles.header : ""}`}>
              <ListHeaderSkeleton />
            </div>
          )
        )}
      </div>
      <div className={styles.wrapMap}>
        <MapBox
          arrMapProperty={arrMapProperty}
          type={type}
          showMap={effectiveShowMap}
          hoveredProperty={hoveredProperty}
          expand={expand}
          increaseWidth={increaseWidth}
        />
        {/* {!isPreOn && (
          <div className={styles.MapButton}>
            <MapToggleButton
              showMap={showMap}
              setShowMap={setShowMap}
              type={type}
            />
          </div>
        )} */}
        {!expand && (
          <>
            {isPreOn && isMobile ? (
              <div
                className={`${styles.preListBottomSidebar} ${
                  isPreListExpanded ? styles.preListExpanded : ""
                }`}
              >
                <button
                  className={styles.expandButton}
                  onClick={() => setIsPreListExpanded(!isPreListExpanded)}
                  aria-label={isPreListExpanded ? "Collapse" : "Expand"}
                >
                  <img
                    src="/images/uparrow.svg"
                    alt={isPreListExpanded ? "Collapse" : "Expand"}
                    width={30}
                    height={30}
                    style={{
                      transform: isPreListExpanded ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.3s ease"
                    }}
                  />
                </button>
                <div className={styles.preListSidebarContent}>
                  {isPreListLoading ? (
                    <div className={styles.preListLoading}>Loading...</div>
                  ) : preListData.length > 0 ? (
                    <>
                      <PreListCards data={preListData} />
                      <div
                        ref={ref}
                        className={styles.loadMore}
                        style={{
                          height: "1px"
                        }}
                      >
                        {isFetchingNextPrePage && <BeatLoaderC color="#272727" />}
                      </div>
                    </>
                  ) : (
                    <NoDataFoundC panelIndex={3} properties />
                  )}
                </div>
              </div>
            ) : (!isPreOn && isMobile) ? (
              // Mobile bottom sheet for regular listings (PRE off)
              <div
                className={`${styles.preListBottomSidebar} ${
                  isPreListExpanded ? styles.preListExpanded : ""
                }`}
              >
                {/* PRE pins CTA while expanded */}
                <button
                  className={styles.expandButton}
                  onClick={() => setIsPreListExpanded(!isPreListExpanded)}
                  aria-label={isPreListExpanded ? "Collapse" : "Expand"}
                >
                  <img
                    src="/images/uparrow.svg"
                    alt={isPreListExpanded ? "Collapse" : "Expand"}
                    width={30}
                    height={30}
                    style={{
                      transform: isPreListExpanded ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.3s ease"
                    }}
                  />
                </button>
                <div className={styles.preListSidebarContent}>
                  {isLoading ? (
                    <div className={styles.preListLoading}>Loading...</div>
                  ) : (
                    <>
                    {
                      !isPreListExpanded && (
                        <div className={styles.sheetHeader}>
                        Over {totalCount} {totalCount === 1 ? "Property" : "Properties"}
                      </div>
                      )
                    }
                      
                      {renderPropertyGrid(arrProperty?.pages) ?? (
                        <NoDataFoundC panelIndex={3} properties={true} />
                      )}
                      <div
                        ref={ref}
                        className={styles.loadMore}
                        style={{
                          height: "1px"
                        }}
                      >
                        {isFetchingNextPage && <BeatLoaderC color="#272727" />}
                      </div>
                    </>
                  )}
                </div>
              </div>
            ) : (
              <div
                className={`${styles.propertyList} ${
                  showMap ? styles.showList : ""
                }`}
                ref={listingWrapRef}
                style={{ opacity: isPlaceholderData ? 0.5 : 1 }}
              >
                {isPreOn ? (
                  <div className={styles.preListWrap}>
                    {isPreListLoading ? (
                      <PreListTable isLoading={true} hasData={false} />
                    ) : preListData.length > 0 ? (
                      <>
                        <PreListTable 
                          data={preListData}
                          isLoading={isPreListLoading}
                          isPlaceholderData={isPreListPlaceholderData}
                          hasData={true}
                        />
                        <div
                          ref={ref}
                          className={styles.loadMore}
                          style={{
                            height: "1px"
                          }}
                        >
                          {isFetchingNextPrePage && <BeatLoaderC color="#272727" />}
                        </div>
                      </>
                    ) : (
                      <NoDataFoundC panelIndex={3} properties />
                    )}
                  </div>
                ) : (
              <>
                {!isLoading ? (
                  <>
                    {totalCount > 0 && (
                      <div className={`${!showMap ? styles.header : ""}`}>
                        <PropertyListHeader
                          title={objPropertyListH.title}
                          type={type}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <div className={`${!showMap ? styles.header : ""}`}>
                    <ListHeaderSkeleton />
                  </div>
                )}
                {isLoading ? (
                  <>
                    {layout !== "list" ? (
                      <div className={styles.propertyWrap}>
                        {skeletonArray.map((_, index: any) => (
                          <React.Fragment key={index}>
                            <PropertyListCardSkeleton />
                          </React.Fragment>
                        ))}arrProperty
                      </div>
                    ) : (
                      <div className={styles.propertyWrapList}>
                        <ListHeaderTitleSkeleton />
                        {skeletonArray.map((_, index: any) => (
                          <React.Fragment key={index}>
                            <PropertyListSkeleton />
                          </React.Fragment>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {layout !== "list" &&
                      (renderPropertyGrid(arrProperty?.pages) ?? (
                        <NoDataFoundC panelIndex={3} properties={true} />
                      ))}
                  </>
                )}
                {arrProperty?.pages && !isLoading && layout === "list" && (
                  <>
                    {(type === "investor" 
                      ? arrProperty?.pages[0]?.data?.length !== 0
                      : arrProperty?.pages[0]?.data?.properties?.length !== 0) ? (
                      <div
                        className={`${
                          isPlaceholderData ? styles.isPlaceholderData : ""
                        } ${styles.propertyListWrap}`}
                      >
                        <ListTable
                          type={type}
                          arrProperty={arrProperty}
                          isPlaceholderData={isPlaceholderData}
                        />
                      </div>
                    ) : (
                      <NoDataFoundC panelIndex={3} properties={true} />
                    )}
                  </>
                )}
                <div
                  ref={ref}
                  className={styles.loadMore}
                  style={{
                    height: "1px"
                  }}
                >
                  {isFetchingNextPage && <BeatLoaderC color="#272727" />}
                </div>
              </>
            )}
          </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default React.memo(PropertyListing);
